import { useCallback, useState } from "react";
import Keycloak from "keycloak-js";
import { createContainer } from "unstated-next";
import { useEffectOnce } from "react-use";
export var keycloakConfig = {
    url: process.env.REACT_APP_KEYCLOAK_HOST + "/auth",
    realm: process.env.REACT_APP_KEYCLOAK_REALM || "",
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENTID || "",
};
export var defaultKeycloakInitOptions = {
    onLoad: "login-required",
    flow: "standard",
    checkLoginIframe: false,
};
export function useKeycloak(initialState) {
    if (initialState === void 0) { initialState = {
        initOptions: defaultKeycloakInitOptions,
        config: keycloakConfig,
    }; }
    var initOptions = initialState.initOptions, config = initialState.config;
    var keycloak = useState(Keycloak(config))[0];
    var _a = useState(false), isKeycloakInitialized = _a[0], setIsKeycloakInitialized = _a[1];
    var login = useCallback(function () {
        keycloak.login();
    }, [keycloak]);
    var logout = useCallback(function () {
        keycloak.logout();
    }, [keycloak]);
    useEffectOnce(function () {
        keycloak.init(initOptions).then(function () {
            setIsKeycloakInitialized(true);
        });
    });
    var getToken = useCallback(function () {
        return keycloak.token;
    }, [keycloak.token]);
    var getParsedToken = useCallback(function () {
        return keycloak.tokenParsed;
    }, [keycloak.tokenParsed]);
    var isLoggedIn = useCallback(function () {
        return keycloak.authenticated;
    }, [keycloak.authenticated]);
    var hasRealmRole = useCallback(function (roles) {
        return roles.some(function (role) { return keycloak.hasRealmRole(role); });
    }, [keycloak]);
    var hasResourceRole = useCallback(function (roles) {
        return roles.some(function (role) { return keycloak.hasResourceRole(role); });
    }, [keycloak]);
    var hasRole = useCallback(function (roles) {
        return hasRealmRole(roles) || hasResourceRole(roles);
    }, [hasRealmRole, hasResourceRole]);
    var updateToken = useCallback(function (successCallback) {
        return keycloak
            .updateToken(5)
            .then(function (refreshed) {
            successCallback();
        })
            .catch(login);
    }, [keycloak, login]);
    return {
        isKeycloakInitialized: isKeycloakInitialized,
        keycloak: keycloak,
        login: login,
        logout: logout,
        isLoggedIn: isLoggedIn,
        getToken: getToken,
        getParsedToken: getParsedToken,
        hasRealmRole: hasRealmRole,
        hasResourceRole: hasResourceRole,
        hasRole: hasRole,
        updateToken: updateToken,
    };
}
export var KeycloakContainer = createContainer(useKeycloak);
